export enum ComparatorEnum {
    equals = 0,
    notEquals = 1,
    gt = 2,
    lt = 3,
    gte = 4,
    lte = 5,
    contains = 6,    
    startsWith = 7,
    endsWith = 8,
    notContains = 9,
    dateIs = 10,
    dateIsNot = 11,
    dateBefore = 12,
    dateAfter = 13,
    In = 14,
    NotIn = 15,

  }

  export enum Sort {
    ASC = 1,
    DESC= -1  

  }

  export enum DocumentTypeEnum {
    // RC = "Registro civil",
    // TI = "Tarjeta de identidad",
    CC = "Cédula de ciudadanía",
    TE = "Tarjeta de extranjería",
    CE = "Cédula de extranjería",
    NIT = "Número de identificación tributaria",
    PP = "Pasaporte",
    PEP = "Permiso especial de permanencia",
    DIE = "Documento de identificación extranjero",
    NUIP = "NUIP"
  }

  export enum UserRoleEnum {
    Employee = 1,
    AdminWorkCenter = 2,
    Root = 3,
    AdminCompany = 4
  }

  export enum EppRequestStatusEnum {
      REQUESTED = 1,
      APPROVED = 2,
      DELIVERED = 3,
      CANCELLED = 4,
      }

  // El backend serializa todos los enums como string (JsonStringEnumConverter global en Program.cs),
  // por eso estos enums usan el nombre exacto en vez del valor numérico subyacente.
  export enum InspectionStatusEnum {
    Open = 'Open',
    Sent = 'Sent',
    Cancelled = 'Cancelled'
  }

  export enum ItemReportValue {
    Yes = 'Yes',
    No = 'No',
    NotApplicable = 'NotApplicable'
  }

  export enum PeriodicityEnum {
    Diario = 'DIARIO',
    Semanal = 'SEMANAL',
    Quincenal = 'QUINCENAL',
    Mensual = 'MENSUAL',
    Bimestral = 'BIMESTRAL',
    Trimestral = 'TRIMESTRAL',
    Semestral = 'SEMESTRAL',
    Anual = 'ANUAL',
    Bienal = 'BIENAL'
  }

  export enum StorageKeys {
    CurrentUser = '59CDBBDF-F7C6-4AFF-97F1-D7F0085AD761'
  }
   